const getUsers = ({ purchasingLimits }) => purchasingLimits.map(pLimit => pLimit.user);


export default {
  getUsers,
};
